// local
// actions
import * as SimpleModal from '../simpleModal';
import { pending, rejected } from '../async';
import dispatchError from '../error';
import { showSnackbar } from '../snackbar';
import { updateRow } from './data';
// consts
import { STATUS } from 'salvus-shared/consts/patient';
// api
import Patient from 'app/api/patient';

const ACTION_KEY = 'MODAL_ENABLE_PATIENT';

export const openModal = (data, onSuccessCallback) => SimpleModal.openModal(ACTION_KEY, data, onSuccessCallback);

export const closeModal = () => SimpleModal.closeModal(ACTION_KEY);

export const init = (id, data, onSuccessCallback) => dispatch => {
    dispatch(pending(ACTION_KEY));
    Patient.init(id, data)
        .then(payload => {
            dispatch(updateRow(payload));
            if (data.oldStatus === STATUS.NEW) {
                dispatch(showSnackbar({ title: `O paciente ${payload.name} foi ativado com sucesso!`, action: true }));
            } else {
                dispatch(showSnackbar({ title: `O paciente ${payload.name} foi reativado com sucesso!`, action: true }));
            }
            if (onSuccessCallback) {
                onSuccessCallback();
            }
            dispatch(closeModal());
        })
        .catch(err => {
            dispatch(rejected(ACTION_KEY, err));
            dispatchError(dispatch, err, false);
        });
};
